import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import * as s from './styled-vars-favoritas';
import { icons } from '../../../../assets';

// Limite duro do produto: max 8 favoritos por thing. Usado pra mostrar
// o contador X/8 e indicar visualmente quando o limite e atingido.
const MAX_FAVORITES = 8;

const VarsFavoritas = ({ thingId }) => {
  const { favorites } = useSelector((state) => state.usuario);
  const [favoritesThing, setFavoritesThings] = useState([]);
  // Lista de IDs que acabaram de mudar (entrou/saiu) — usada pra animar a
  // entrada da tag. Ref pra nao causar re-render extra.
  const previousIdsRef = useRef([]);
  const [enteringIds, setEnteringIds] = useState(new Set());

  useEffect(() => {
    if (thingId) {
      let newVars = [];
      favorites?.vars?.forEach((thingFav) => {
        if (String(thingFav.id) === String(thingId)) {
          newVars.push(thingFav.variables);
        }
      });
      if (newVars[0]) setFavoritesThings(newVars[0]);
      else setFavoritesThings([]);
    }
  }, [thingId, favorites]);

  // Detecta mudancas e marca novas tags com animacao de entrada (cleared
  // depois de 600ms).
  useEffect(() => {
    const currentIds = favoritesThing.map((v) => v.id);
    const prevIds = previousIdsRef.current;
    const added = currentIds.filter((id) => !prevIds.includes(id));
    if (added.length > 0) {
      setEnteringIds(new Set(added));
      const timer = setTimeout(() => setEnteringIds(new Set()), 600);
      previousIdsRef.current = currentIds;
      return () => clearTimeout(timer);
    }
    previousIdsRef.current = currentIds;
    return undefined;
  }, [favoritesThing]);

  const count = favoritesThing.length;
  const limitReached = count >= MAX_FAVORITES;

  // Cor do contador: vazio cinza, parcial label, limite atingido amarelo.
  const counterTone = useMemo(() => {
    if (count === 0) return 'muted';
    if (limitReached) return 'warn';
    return 'ok';
  }, [count, limitReached]);

  return (
    <s.Container className="style-container-aplicacao">
      <s.Header>
        <s.HeaderLeft>
          <s.StarIcon src={icons.Star} alt="" />
          <s.HeaderTitle>Favoritos</s.HeaderTitle>
          <s.Counter tone={counterTone}>
            {count}/{MAX_FAVORITES}
          </s.Counter>
        </s.HeaderLeft>
        {count === 0 && (
          <s.HelperText>
            Toque na ⭐ de uma variável abaixo para favoritar.
          </s.HelperText>
        )}
        {limitReached && (
          <s.HelperText warn>
            Limite atingido — remova uma para adicionar outra.
          </s.HelperText>
        )}
      </s.Header>
      {count > 0 && (
        <s.TagList>
          {favoritesThing.map(({ id, name }) => (
            <s.VarTag
              key={id}
              entering={enteringIds.has(id) ? 'true' : undefined}
            >
              {name}
            </s.VarTag>
          ))}
        </s.TagList>
      )}
    </s.Container>
  );
};

export default VarsFavoritas;
